import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        main: {
            width: '100%',
        },
        container: {
            maxWidth: {lg: remCalc(1400), base: '100%'},
            mx: 'auto',
            mb: {base: 0, md: remCalc(16), lg: remCalc(40)},
            px: {base: remCalc(16), sm: remCalc(24), lg: 0},
            textAlign: 'center',
            justifyContent: 'center',
        },
        sortingSwiper: {
            mb: remCalc(24),
        },
        chevronIcon: {
            width: {base: remCalc(24), sm: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            height: {base: remCalc(24), sm: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            position: 'absolute',
            backgroundColor: 'background.default',
            borderWidth: remCalc(1),
            borderColor: 'border.dark',
            borderRadius: '50%',
            top: {base: remCalc(166), sm: remCalc(84), md: remCalc(113), lg: remCalc(166)},
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: '10',
        },
        heading: {
            py: {base: remCalc(16), md: remCalc(40)},
            w: '100%',
        },
        bodycopy: {
            w: '100%',
            textStyle: 'body-large',
            pb: remCalc(40),
        },
        tilecontainer: {
            w: '100%',
            gap: {base: 0, sm: remCalc(16), md: remCalc(24)},
            pb: remCalc(24),
        },
        tile: {
            w: '100%',
            gap: remCalc(24),
        },
        ctacontainer: {
            w: '100%',
            gap: {base: remCalc(16), md: remCalc(24)},
        },
        cta: {
            minW: {base: remCalc(227), md: remCalc(310), lg: remCalc(213)},
            textDecoration: 'none !important',
        },
    },
}
